import ReservationsProvider from "providers/ReservationsProvider"
import ReservationsTemplate from "components/templates/ReservationsTemplate"

const Reservations = () => {
  return (
    <ReservationsProvider>
      <ReservationsTemplate />
    </ReservationsProvider>
  )
}

export default Reservations
